import { useState, useCallback } from 'react';

interface IntervalConfig {
  minInterval: number;
  maxInterval: number;
}

const DEFAULT_CONFIG: IntervalConfig = {
  minInterval: 30,
  maxInterval: 60,
};

/**
 * Hook para gerenciar a configuração de intervalo de envio em massa.
 */
export const useBulkSendConfig = () => {
  const [config, setConfig] = useState<IntervalConfig>(DEFAULT_CONFIG);

  const updateConfig = useCallback((min: number, max: number) => {
    setConfig({ minInterval: min, maxInterval: max });
  }, []);

  return {
    intervalConfig: config,
    updateIntervalConfig: updateConfig,
  };
};